import React from 'react';

export function Container2({ className, ...props }) {
  const containerClassName = `mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 ${className}`;

  return <div className={containerClassName} {...props} />;
}